import InnerComponent from '@Components/Purchase/AccountPayableInvoice/AccountPayableInvoiceView';
import orgContainer from '@Components/AppContainer';

const AccountPayableInvoiceView = () => ((orgContainer(InnerComponent)));
export default AccountPayableInvoiceView;
